export default function About() {
  return (
        <center>
            <h1 className="p-4">MOD3 LicenseScreen</h1>
            <center className="pt-4">Support and permission requests: <a href="mailto:cms-infotainment@valtech-mobility.com">cms-infotainment@valtech-mobility.com</a></center>
        </center>
  );
}